export function rbInputStyle(c, dark, { mono = false, error = false } = {}) {
  return {
    width: "100%",
    height: 36,
    padding: "0 10px",
    fontSize: mono ? 12 : 13,
    fontFamily: mono ? "ui-monospace, SFMono-Regular, Menlo, monospace" : "inherit",
    color: c.text,
    background: c.card,
    border: `1px solid ${error ? "#EF4444" : c.cardBdr}`,
    borderRadius: 8,
    outline: "none",
    boxSizing: "border-box",
  };
}

export function rbSelectStyle(c) {
  return {
    ...rbInputStyle(c),
    cursor: "pointer",
    appearance: "none",
  };
}

export function rbCardStyle(c, dark) {
  return {
    background: c.card,
    border: `1px solid ${c.cardBdr}`,
    borderRadius: 12,
    boxShadow: dark ? "0 8px 24px rgba(0,0,0,.2)" : "0 8px 24px rgba(15,23,42,.06)",
  };
}

export function rbSectionTitle(c) {
  return { margin: "0 0 4px", fontSize: 15, fontWeight: 700, color: c.text };
}

export function rbSectionHint(c) {
  return { margin: "0 0 14px", fontSize: 12, color: c.sub, lineHeight: 1.5 };
}
